import React from 'react';
import {reisy, use} from 'reisy';

export const styles = reisy`
@namespace InlineLoader;

@keyframes Spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

Size: 5em;
Border: 0.5em;

wrapper {
	position: relative;
	width: 100%;
	height: 100%;
}

Loader {
	position: absolute;
	top: 0; left: 0;
	width: 100%; height: 100%;
	background: black;
	opacity: 0.4;
	display: flex;
	justify-content: center;
	align-items: center;
}
Spinner {
	width: $Size;
	height: $Size;
	border: $Border solid rgba(255, 255, 255, 0.2);
	border-left-color: white;
	animation: $Spin 1.1s infinite linear;
	border-radius: 50%;

	$Media.smaller {
		width: 3em;
		height: 3em;
		border-width: .3em;
	}
}
`;

const InlineLoader = () => (
	<div {...use(styles.Loader)}>
		<div {...use(styles.Spinner)} />
	</div>
);

export const WrappingLoader = ({loading, children}) => (
	loading
		? <div {...use(styles.wrapper)}>
			{children}
			<InlineLoader />
		</div>
		: children
);

export default InlineLoader;





// WEBPACK FOOTER //
// ./lib/components/inline-loader.js